module.exports = __webpack_public_path__ + "img/数据库.32b3c29f.gif";